import React from "react";

const PayperviewDetail = () => {
  return (
    <>
      <div className="flex w-full max-w-[350px] flex-col gap-2 mt-[20px] mb-[10px]">
        <div className="h-[40px] w-[85%] max-w-[350px] bg-[#1a1919] animate-pulse"></div>
        <div className="h-[20px] w-[150px] bg-[#1a1919] animate-pulse"></div>
        <div className="h-[20px] w-[100px] bg-[#1a1919] animate-pulse"></div>
        <div className="h-[20px] w-[80px] bg-[#1a1919] animate-pulse"></div>
        <div className="h-[80px] w-[90%] max-w-[350px] bg-[#1a1919] animate-pulse"></div>
        <div className="h-[30px] w-[90%] max-w-[350px] bg-[#1a1919] animate-pulse"></div>
      </div>
    </>
  );
};

export default PayperviewDetail;
